export { default as CorePermissionsAdmin } from './Admin';
export { default as CorePermissionsNotAdmin } from './NotAdmin';
export { default as CorePermissionsConsumer } from './Consumer';
export { default as CorePermissionsCanCreate } from './CanCreate';
export { default as CorePermissionsCanEdit } from './CanEdit';
export { default as CorePermissionsReadOnly } from './ReadOnly';
export { default as CorePermissionsReadWrite } from './ReadWrite';
